module.exports = __webpack_public_path__ + "02_bob_black.145c8b43.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_bob_black.png
// module id = 98ZQ
// module chunks = 0